import {
  ADD_TEXT_COLOR_REQUEST,
  ADD_TEXT_COLOR_SUCCESS,
  FETCH_RCE_SETTINGS_SUCCESS,
  SET_USER_COLORS_FAILURE,
  SET_USER_COLORS_REQUEST,
  SET_USER_COLORS_SUCCESS,
  type addTextColorRequest,
  type addTextColorSuccess,
  type fetchRceSettingsFailure,
  type fetchRceSettingsSuccess,
  type setUserColorsFailure,
  type setUserColorsRequest,
  type setUserColorsSuccess,
} from '../actions/rce-settings';

export type RceSettingsState = {
  colorSettings: {
    customColors: string[];
  };
  error: boolean | null;
};

type AnyAction =
  | ReturnType<typeof addTextColorRequest>
  | ReturnType<typeof addTextColorSuccess>
  | ReturnType<typeof fetchRceSettingsSuccess>
  | ReturnType<typeof fetchRceSettingsFailure>
  | ReturnType<typeof setUserColorsRequest>
  | ReturnType<typeof setUserColorsSuccess>
  | ReturnType<typeof setUserColorsFailure>;

const initialState: RceSettingsState = { colorSettings: { customColors: [] }, error: null };

export default function rceSettingsReducer(state = initialState, action: AnyAction) {
  switch (action.type) {
    case ADD_TEXT_COLOR_REQUEST:
      return {
        ...state,
        colorSettings: {
          customColors: [...state.colorSettings.customColors, action.payload.color],
        },
      };

    case SET_USER_COLORS_REQUEST:
    case SET_USER_COLORS_FAILURE:
      return {
        ...state,
        colorSettings: {
          customColors: action.payload.colors,
        },
      };

    case SET_USER_COLORS_SUCCESS:
    case ADD_TEXT_COLOR_SUCCESS:
    case FETCH_RCE_SETTINGS_SUCCESS:
      return action.payload.rceSettings;

    default:
      return state;
  }
}
